export function parseBoolean(value: string | boolean | null | undefined): boolean {
  if (typeof value === 'boolean') return value;
  if (!value) return false;
  const normalized = value.toString().toLowerCase().trim();
  return ['true', '1', 'yes', 'on'].includes(normalized);
}
